import {
  Box,
  Button,
  Grid,
  GridItem,
  Heading,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { infoModalAtom } from "../state/state";
import Chart from "./chart";
import InfoModal from "./infoModal";
import PdfDownloadButton from "./pdf/pdfDownloadButton";
import ResultsTextualSummary from "./resultsTextualSummary";
import i18n from "../language/i18n";

const Results = () => {
  const { t } = useTranslation();
  const infoModal = useDisclosure();
  const [modalContent, setModalContent] = useRecoilState(infoModalAtom);

  /**
   * Read info modal file content on mount, if not set in global state (from AWS).
   */
  useEffect(() => {
    if (!modalContent) {
      const language = i18n.language;
      fetch(`/infoModal_${language}.md`)
        .then((response) => response.text())
        .then((result) => setModalContent(result));
    }
  }, []);

  return (
    <>
      <Heading variant="redDot" mt="10">
        {t("components.results.title")}
      </Heading>
      <Box bg="white" padding="5">
        <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }}>
          <GridItem order={{ base: 2, lg: 1 }}>
            <ResultsTextualSummary />
          </GridItem>
          <GridItem order={{ base: 1, lg: 2 }}>
            <Chart />
          </GridItem>
        </Grid>
        <Grid
          templateColumns={{ base: "1fr", md: "1fr auto" }}
          gap="20"
          mt="20"
          mb="5"
          alignItems="end"
        >
          <GridItem>
            <Text>{t("components.results.footerText")}</Text>
          </GridItem>
          <GridItem>
            <Stack spacing="3">
              <InfoModal
                isOpen={infoModal.isOpen}
                onClose={infoModal.onClose}
                title={t("components.results.buttonInfo")}
                body={modalContent ?? ""}
              />
              <Button
                bg="black"
                color="white"
                colorScheme="black"
                onClick={infoModal.onOpen}
              >
                {t("components.results.buttonInfo")}
              </Button>
              <PdfDownloadButton>
                {t("components.results.buttonPdf")}
              </PdfDownloadButton>
            </Stack>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};

export default Results;
